import { useEffect } from 'react';

const useE2EReadiness = (flag: string, ready: boolean) => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const { dataset } = document.documentElement;

    dataset[flag] = String(ready);
  }, [flag, ready]);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    return () => {
      document.documentElement.dataset[flag] = 'false';
    };
  }, [flag]);
};

export { useE2EReadiness };
